import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from '@core/services/header.service';

@Component({
  standalone: false,
  selector: 'app-org-structure',
  templateUrl: './org-structure.component.html',
  styleUrls: ['./org-structure.component.scss'],
})
export class OrgStructureComponent implements OnInit {
  tab: 'departments' | 'teams' = 'departments';

  constructor(private router: Router, private header: HeaderService) {}

  ngOnInit(): void {
    this.tab = this.router.url.includes('/shifts') ? 'teams' : 'departments';
    this.header.setTitle('Departments & Teams');
  }
}
